import React, { useEffect } from 'react'
import { AnimatePresence, motion, MotionConfig } from 'motion/react'

import './src/styles/global.css'

import { CookieConsent } from './src/components/elements/cookie-consent'
import { initAnalytics } from './src/lib/analytics'
import { autoDetectLocale } from './src/lib/locale-detect'
import { revealFade } from './src/components/animation/tokens'

// Page transition wrapper — opacity-only crossfade between routes, using the
// shared `revealFade` tween (the site's "compact" reveal: opacity, no y) so
// route changes share one motion feel with content reveals. Also mounts the
// cookie-consent banner once at the layout root so it appears on every page.
export const wrapPageElement = ({ element, props }) => (
  <MotionConfig reducedMotion="user">
    <ConsentBootstrap />
    <AnimatePresence mode="wait">
      <motion.div
        key={props.location.pathname}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={revealFade}
      >
        {element}
      </motion.div>
    </AnimatePresence>
    <CookieConsent />
  </MotionConfig>
)

// Tiny client-only component that fires the analytics loader once
// per session AND runs the browser-language auto-detect on first
// visit. Kept as a component (rather than a top-level call) so it
// runs inside React's lifecycle and not at module load time.
function ConsentBootstrap() {
  useEffect(() => {
    autoDetectLocale()
    initAnalytics()
  }, [])
  return null
}

// Scroll to top on route change
export const shouldUpdateScroll = ({ routerProps }) => {
  const { location } = routerProps

  // For hash links, let browser handle it
  if (location.hash) {
    return true
  }

  // Scroll to top after the exit fade — kept in sync with the crossfade
  // duration so the reset lands once the old page is gone, not mid-fade.
  setTimeout(() => {
    window.scrollTo(0, 0)
  }, revealFade.duration * 1000)

  return false
}
